<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Expenses</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip left class="mr-0">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="$emit('add')">
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>Add new</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table :headers="headers" :items="payments" class="elevation-1" hide-actions>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.payment_date }}</td>
          <td>{{ props.item.account_heads___title }}</td>
          <td>{{ props.item.amount }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn flat icon small v-on="on" @click="() => onPressDelete(props.item)">
                  <v-icon dark>clear</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template slot="no-data"> </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ["payments"],
  data() {
    return {
      relatedFiles: [],
      // headers: [
      //   { text: "Date", value: "name", sortable: false },
      //   ...(type == 'payment' ? [{ text: "Head", value: "name", sortable: false }] : []),
      //   { text: "Method", value: "name", sortable: false },
      //   { text: "Amount", value: "name", sortable: false },
      //   { text: "Actions", value: "name", sortable: false },
      // ],
    };
  },

  computed: {
    headers() {
      return [
        { text: "Date", value: "name", sortable: false },
        { text: "Head", value: "name", sortable: false },
        { text: "Amount", value: "name", sortable: false },
        { text: "Actions", value: "name", sortable: false },
      ];
    },
  },

  methods: {
    async onPressDelete(payment) {
      this.$confirm("Do you really want to DELETE file ?").then((isConfirmed) => {
        if (isConfirmed) {
          this.$emit("delete", payment);
        }
      });
    },
  },

  mounted() {
    // this.initUppy();
  },

  watch: {},

  beforeDestroy() {},

  created() {},
};
</script>
